export const translationPT = {
  top: {
    text_1: 'Comida fresca & um planeta melhor',
    text_2: 'MILHARES',
    text_3: 'DE RECEITAS',
    text_4: 'Um lugar que ajuda você a gerenciar os ingredientes',
    text_5: 'Receitas de várias culinárias',
    text_6: 'Menus semanais, lista de compras',
  },
  main_function: {
    text_1: 'Funções principais',
    text_1_1: 'Mantenha sua comida fresca!',
    text_1_2: 'Receba alertas do nosso verificador de frescor para evitar desperdiçar comida',
    text_2_1: 'Sugestões de receitas com IA',
    text_2_2: 'Descubra receitas de várias culinárias do mundo com base nos ingredientes que sobraram na sua geladeira',
    text_3_1: 'Menus para a semana inteira',
    text_3_2: 'Crie menus para a semana inteira',
    text_4_1: 'Lista de compras',
    text_4_2: 'Crie e atualize listas de compras para se preparar para as compras',
    text_5: 'Baixar',
    text_6: 'O iFridge vai ajudar você',
    text_7_1: 'Torne-se um(a) melhor dona(o) de casa',
    text_7_2: 'Reduza o desperdício & ajude a criar um planeta mais saudável',
    text_7_3: 'Aproveite cozinhar',
  },
  rate_box: {
    text_1: 'Avaliações de usuários',
  },
  faqs: {
    text_1: 'Perguntas frequentes',
    text_2_1: 'Quais tipos de contas existem? Posso usar o aplicativo gratuitamente?',
    text_2_2: `Você tem o primeiro mês para usar todas as funções do aplicativo gratuitamente e sem anúncios.
      <br /><br />Após o primeiro mês, sua conta será automaticamente convertida para uma CONTA GRATUITA.
      <br /><br />Com uma CONTA GRATUITA, você pode usar as funções básicas do aplicativo, como: gerenciar ingredientes, relatório diário do status dos ingredientes. Algumas funções avançadas, como sugestões de receitas com IA, menus semanais e lista de compras, não estarão disponíveis. Anúncios também aparecerão enquanto você usa o aplicativo.
      <br /><br />Para usar todas as funções do aplicativo sem anúncios, você precisa fazer um upgrade para uma CONTA PREMIUM com um custo mensal muito acessível.`,
    text_3_1: 'Quanto custa uma CONTA PREMIUM?',
    text_3_2: `Você pode assinar mensalmente ou anualmente.
      <br /><br />Custo mensal: $0,99/mês.
      <br /><br />Custo anual: $9,99/ano.
      <br /><br />Não há outras taxas.`,
    text_4_1: 'Posso assinar uma CONTA PREMIUM sem pagar?',
    text_4_2: `Sim, é possível.
      <br /><br />Para assinar uma CONTA PREMIUM, você pode usar Pontos iFridge.
      <br /><br />Os Pontos iFridge podem ser adquiridos na App Store/Google Play: Na tela Configurações, toque no menu Pontos para acessar a tela de compra de Pontos.
      <br /><br />Ou você pode ganhar Pontos iFridge assistindo a anúncios: Na tela Configurações, toque no menu Outras Configurações e selecione Assistir a anúncios.`,
    text_5_1: 'Eu ganho Pontos iFridge assistindo a anúncios?',
    text_5_2: `Sim, você pode ganhar Pontos iFridge assistindo a anúncios.
      <br /><br />Dependendo do seu país, você receberá uma quantidade específica de Pontos iFridge por cada anúncio assistido (de acordo com os regulamentos do Google Admob). Após assistir a um anúncio, você precisa esperar 20 minutos para poder assistir ao próximo.`,
    text_6_1: 'Posso ganhar Pontos iFridge indicando amigos?',
    text_6_2: `Sim, você pode ganhar Pontos iFridge indicando amigos.
      <br /><br />Dependendo do seu país, você pode receber uma certa quantidade de Pontos iFridge ao compartilhar informações sobre o iFridge em redes sociais como Facebook, Twitter, etc.
      <br /><br />Em um mês, você só pode receber Pontos iFridge uma vez por indicação.`,
    text_7_1: 'Meus dados pessoais estão armazenados com segurança? Eles são compartilhados com terceiros?',
    text_7_2:
      'Seus dados estão armazenados exclusivamente no seu celular e são totalmente seguros. Não armazenamos seus dados pessoais em nossos servidores, nem os compartilhamos com terceiros.',
    text_8_1: 'Se eu precisar de suporte, como posso entrar em contato?',
    text_8_2: `Você pode entrar em contato conosco através da função Entre em contato: Na tela Configurações, selecione Outras Configurações e, em seguida, Entre em contato.
      <br /><br />Ou envie pedidos de suporte/feedback diretamente para o e-mail: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'O amor pode ir e vir,',
    text_2: 'mas a fome visita todos os dias',
  },
};
